import { PoolbettingError } from './PoolbettingError.js';

/**
 * Error instance representing when a feature or use case inst bootstrapped correctly.
 * Ie. som initializations is needed on beforehand.
 */
export class NotInitializedError extends PoolbettingError {
  constructor(message = 'Not initialized', options?: ErrorOptions) {
    super(message, options, 'UNKNOWN');
    this.name = 'NotInitializedError';
  }
}
